// extracted by css-extract-rspack-plugin
export default {"page":"page-BuC4oX","content":"content-FtQXVM","actions":"actions-e7uxU_","title":"title-uwNVep","body":"body-APZ1iP"};